// extracted by mini-css-extract-plugin
export default {"giftPointBody":"CustomerCashTerms_giftPointBody__bguY5","okBtn":"CustomerCashTerms_okBtn__JS62y","cashNotes":"CustomerCashTerms_cashNotes__zVbF0"};